"use strict";
function multipleEmailsValidator() {
    return function (control) {
        var pattern = /^(\s*(\S+@[\w\d]+(\.[\w\d]+)+)\s*\,?)+$/;
        var value = control.value;
        if (value && value !== '' && !pattern.test(value)) {
            return { 'invalidEmail': true };
        }
        return null;
    };
}
exports.multipleEmailsValidator = multipleEmailsValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/multiple-emails.validator.js